import { NavLink, Outlet } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { ImpersonationBanner } from "./ImpersonationBanner";
import { BookOpenText, LayoutDashboard, LogOut, Sparkles } from "lucide-react";

const NAV = [
  { to: "/admin/courses", key: "admin.courses", icon: BookOpenText, testId: "admin-nav-courses" },
];

export function AdminShell() {
  const { t, lang, toggle } = useI18n();
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-[#FDFBF7]" dir={lang === "ar" ? "rtl" : "ltr"} data-testid="admin-shell">
      <ImpersonationBanner />
      <div className="grid grid-cols-1 md:grid-cols-[240px_1fr]">
        <aside className="border-r border-black/5 bg-white/60 backdrop-blur-xl md:min-h-screen p-4 md:p-6">
          <div className="flex items-center gap-2 mb-8">
            <span className="inline-block h-9 w-9 rounded-2xl bg-[#4361EE] grid place-items-center text-white shadow-[0_3px_0_#2A3EB1]">
              <Sparkles className="h-4 w-4" />
            </span>
            <div>
              <div className="font-black text-lg leading-none">{lang === "ar" ? "سباركل" : "Sparkl"}</div>
              <div className="text-xs font-bold text-[#4361EE]">{t("admin.nav")}</div>
            </div>
          </div>

          <nav className="flex flex-col gap-1" data-testid="admin-sidebar">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-bold transition ${
                    isActive
                      ? "bg-[#4361EE] text-white shadow-[0_3px_0_#2A3EB1]"
                      : "text-black/70 hover:bg-black/5"
                  }`
                }
                data-testid={item.testId}
              >
                <item.icon className="h-4 w-4" />
                <span>{t(item.key)}</span>
              </NavLink>
            ))}
          </nav>

          <div className="mt-8 space-y-2 border-t border-black/5 pt-4">
            <NavLink
              to="/dashboard"
              className="flex items-center gap-3 rounded-xl px-3 py-2 text-xs font-bold text-black/60 hover:bg-black/5"
              data-testid="admin-back-dashboard"
            >
              <LayoutDashboard className="h-4 w-4" />
              {lang === "ar" ? "لوحة التعلّم" : "Learner dashboard"}
            </NavLink>
            <button
              onClick={toggle}
              className="w-full text-start flex items-center gap-3 rounded-xl px-3 py-2 text-xs font-bold text-black/60 hover:bg-black/5"
              data-testid="admin-lang-toggle"
            >
              <span className="text-base">🌐</span> {t("lang.toggle")}
            </button>
            <button
              onClick={logout}
              className="w-full text-start flex items-center gap-3 rounded-xl px-3 py-2 text-xs font-bold text-black/60 hover:bg-black/5"
              data-testid="admin-logout"
            >
              <LogOut className="h-4 w-4" />
              {t("dashboard.logout")}
            </button>
          </div>

          <div className="mt-6 text-xs text-black/50">
            <div className="font-bold text-black/70">{user?.name}</div>
            <div>{user?.email}</div>
            <div className="mt-1 inline-block rounded-full bg-[#FFB703]/20 text-[#7A4B00] px-2 py-0.5 font-bold">
              {user?.role}
            </div>
          </div>
        </aside>

        <main className="p-6 md:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
